export const IntranetVacation = {
    path: '/intranet_vacations',
    name: 'intranet_vacations',
    component: () => import('@/views/Intranet/IntranetVacationPage.vue'),
    children: [
        {
            path: '/intranet_vacations/add',
            name: 'intranet_vacations.add',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {addAction: true, intranet: true}
        },
        {
            path: '/intranet_vacations/edit/:id',
            name: 'intranet_vacations.edit',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {updateAction: true, intranet: true}
        },
        {
            path: '/intranet_vacations/delete/:id',
            name: 'intranet_vacations.delete',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {deleteAction: true, intranet: true}
        },
        {
            path: '/intranet_vacations/view/:id',
            name: 'intranet_vacations.view',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {viewAction: true, intranet: true}
        },
        {
            path: '/absence_requests/vacation_title/:id',
            name: 'intranet_vacations.vacation_title',
            component: () => import('@/views/Absence/AbsenceRequest/Form/VacationTitle.vue'),
        },
        {
            path: '/intranet_vacations/set_decision/:id/:module',
            name: 'intranet_vacations.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/intranet_vacations/timelines/:id/:module',
            name: 'intranet_vacations.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/intranet_vacations/documents/:id',
            name: 'intranet_vacations.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "VACATION"}
        },
    ],
}